import { RECOMMEND_STORE_TYPE } from '../../../../constants/service/app/recommendStoreConstants';
import { _LIST_PAGINATION_MODEL } from '../../app/models';

/**
 *  추천 브랜드 리스트 검색 박스 모델
 */
export const RECOMMEND_STORE_LIST_SEARCH_DATA_MODEL = {
  /**
   *  추천 브랜드 타입
   */
  recommendStoreType: null,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 브랜드 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  추천 브랜드 리스트 검색 옵션 모델
 */
export const RECOMMEND_STORE_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  추천 브랜드 타입
   */
  recommendStoreType: null,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 브랜드 생성일
   */
  createDate: null,
};

/**
 *  추천 브랜드에 연결할 아이템 리스트 필터 옵션 모델
 */
export const RECOMMEND_STORE_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 번호
   */
  storeId: null,
  /**
   *  브랜드명
   */
  storeName: null,
};

/**
 *  추천 브랜드 등록/복사 모델
 */
export const RECOMMEND_STORE_SAVE_MODEL = {
  /**
   *  추천 브랜드 정보
   */
  recommendStoreInfo: {
    /**
     *  추천 브랜드 타입
     */
    type: RECOMMEND_STORE_TYPE.SEARCH_RECOMMEND,
    /**
     *  메모
     */
    memo: null,
  },
  /**
   *  추천 브랜드 아이템 리스트
   */
  recommendStoreItemList: {
    /**
     *  추천 브랜드에 연결할 아이템 리스트
     */
    itemList: {
      /**
       * 리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: RECOMMEND_STORE_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       * pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    },
    /**
     *  선택된 추천 브랜드에 연결된 아이템 리스트
     */
    selectedItemList: {
      list: [],
    },
  },
};
